import React from 'react';
import Header from '../components/Header';
import Configurator from '../components/Configurator';
import Footer from '../components/Footer';

const ConfiguratorPage = () => (
  <>
    <Header />
    <Configurator />
    <Footer />
  </>
);

export default ConfiguratorPage;
